module.exports = __webpack_public_path__ + "img/bannerImg01.c36d51a9.png";